<button *ngIf="!isFullScreen" mat-icon-button (click)="goFullscreen()" class="jdm-text-blue fullscreen-button" >
	<mat-icon [ngClass]="size"aria-label="Example icon-button with a heart icon">fullscreen</mat-icon>
</button>
<button *ngIf="isFullScreen" mat-icon-button (click)="exitFullscreen()" class="jdm-text-blue fullscreen-button">
	<mat-icon [ngClass]="size" aria-label="Example icon-button with a heart icon">fullscreen_exit</mat-icon>
</button>